export const AI_SEARCH_QUERY_MIN_LENGTH = 3;
export const AI_SEARCH_QUERY_MAX_LENGTH = 300;
export const AI_SEARCH_QUERY_LENGTH_MESSAGE = `Please enter between ${AI_SEARCH_QUERY_MIN_LENGTH} and ${AI_SEARCH_QUERY_MAX_LENGTH} characters.`;
